import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqData: FAQItem[] = [
  {
    question: '酷漫屋的漫画都是免费的吗？',
    answer: '是的，酷漫屋上所有漫画资源均可免费在线阅读，无需付费，无需注册。我们致力于为漫画爱好者提供最便捷的免费漫画阅读体验。',
  },
  {
    question: '酷漫屋支持哪些类型的漫画？',
    answer: '酷漫屋涵盖了日漫、韩漫、国漫等多种类型的免费漫画资源，包括热血、恋爱、奇幻、冒险、搞笑、战斗、悬疑、玄幻等丰富题材，满足不同读者的喜好。',
  },
  {
    question: '如何在酷漫屋上搜索想看的漫画？',
    answer: '您可以使用首页顶部的搜索框直接输入漫画名称搜索，也可以通过分类导航浏览日漫、韩漫、国漫等不同分类的漫画列表，快速找到想看的免费漫画。',
  },
  {
    question: '阅读时是否支持下拉式滚动？',
    answer: '是的，酷漫屋支持下拉式滚动阅读模式，您可以像浏览网页一样流畅地阅读漫画，无需频繁翻页，带来更舒适的阅读体验。',
  },
  {
    question: '漫画更新频率是怎样的？',
    answer: '我们会在漫画官方更新的第一时间同步更新，确保您能及时追更最新章节，不会错过任何精彩内容。',
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-10 md:py-14 px-4 md:px-6" aria-label="常见问题">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 text-center mb-2">
          常见问题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8">关于酷漫屋，你可能想知道</p>

        <div className="space-y-3">
          {faqData.map((item, index) => (
            <div
              key={index}
              className="rounded-lg border border-background-200/70 bg-background-50 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-50/80 transition-colors"
                aria-expanded={openIndex === index}
              >
                <span className="text-sm font-medium text-foreground-900 pr-4">{item.question}</span>
                <span className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-500"></i>
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-60 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}